import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { LoadingSpinner } from "../../shared/LoadingSpinner";
import { CenterContainer } from "../../shared/PopupComponents";
const Container = styled.div.withConfig({
  displayName: "MapLoadingScreen__Container",
  componentId: "sc-n1eg52-0"
})(["color:white;font-size:2em;"]);
const SpinnerOffset = styled.div.withConfig({
  displayName: "MapLoadingScreen__SpinnerOffset",
  componentId: "sc-n1eg52-1"
})(["margin-right:0.5em;margin-top:0.35em;"]);
export const MapLoadingScreen = () => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(CenterContainer, null, /*#__PURE__*/React.createElement(SpinnerOffset, null, /*#__PURE__*/React.createElement(LoadingSpinner, null)), /*#__PURE__*/React.createElement(Container, null, t("game.map_loading")));
};